import { useEffect } from "react";
import { useSelector } from "react-redux";

import messageAudioFile from "../../assets/message.mp3";
import { ReduxState } from "../../types/redux.types";
import usePushNotifications from "./usePushNotifications";

const useNotificationSound = (shouldPlaySound: boolean, desktopMessage: string, deps: any[] = []) => {
  const muted = useSelector<ReduxState, boolean>((state) => state.notifications.muted);
  const { pushNotification } = usePushNotifications();

  useEffect(() => {
    const notificationSound = new Audio(messageAudioFile);

    if (shouldPlaySound && !muted) {
      // push message to desktop
      if (desktopMessage) pushNotification(desktopMessage);

      // play sound
      notificationSound.play().catch((ex) => {
        console.log(ex.message);
      });
    }
  }, deps);
};

export default useNotificationSound;
